import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

// #35219 — the umbrella question flow renders `mode="dark"` fields (light text), so it must sit on the
// same green_90 card as the Policy-wide endorsements and Liability sections; on the beige page the
// labels were unreadable. The text classes mirror liability-coverages-styles for a consistent look.
const styles = (theme) => ({
  umbrellaContainer: {
    background: theme.colorPalette.green_90,
    width: '100%',
    margin: 0,
    padding: theme.spacing(6, 8),
    borderRadius: theme.sizes.roundCorners,
    ...reskinStyles(theme, theme.cardStyles.outlined)
  },
  headerText: {
    fontSize: 14,
    lineHeight: '20px',
    color: theme.onCard.white,
    height: 24
  },
  addAnotherButton: {
    color: theme.onCard.white,
    textTransform: 'none',
    fontSize: 14,
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
});

export default makeStyles(styles);
